/* global wp */
import TextInputField from './text-input-field';

const { __ } = wp.i18n;
const { useState } = wp.element;

/**
 * Validates email address.
 *
 * @param {string} email - Email address as string
 *
 * @return {boolean}
 */
const isValidEmail = (email) => {
	let match = email.match(/\S+@\S+\.\S+/);

	return match && match.length > 0;
};

const EmailField = (props) => {
	const { onInput, onError } = props;
	const [error, setError] = useState('');

	const handleChange = (value) => {
		onInput(value);

		let errorFlag = false;

		if (value && !isValidEmail(value)) {
			errorFlag = true;
			setError(__('Email is not valid.', 'wpmudev'));
		} else if (!value) {
			errorFlag = true;
			setError(__('Email is required.', 'wpmudev'));
		} else {
			setError('');
		}

		onError(errorFlag);
	};

	return (
		<TextInputField
			type="email"
			{...props}
			onInput={(e) => handleChange(e)}
			error={error}
		/>
	);
};

export default EmailField;
